<template>
  <el-row>
    <el-col :span="24">
      <div class="custom-menu">
        <div class="custom-menu-item custom-menu-btn">
          <span><i class="el-icon-menu"></i></span>
        </div>
        <div class="custom-menu-item custom-menu-left">
          <span class="logo-wrapper" @click="$router.push({name: 'home-index'})">
            <img src="/static/logo360tovisit2.png">
          </span>
          <el-menu
            :default-active="activeIndex"
            class="el-menu-custom"
            mode="horizontal"
            @select="handleSelect"
            background-color="#e3e8ee"
            text-color="#edededa6"
            active-text-color="#fff">

            <!-- <el-menu-item index="home-index">
            </el-menu-item> -->
            <el-menu-item index="list-project">
              <span>{{ $t('Virtual Tour') }}</span>
            </el-menu-item>
            <el-menu-item index="list-agency" v-show="accountInfo.role !== 'editor'">
              <span>{{ $t('Public Profile') }}</span>
            </el-menu-item>
            <el-menu-item index="list-manager" v-show="accountInfo.role !== 'editor'">
              <span>{{ $t('Users') }}</span>
            </el-menu-item>
          </el-menu>
        </div>
        <div class="menu-icon custom-menu-item custom-menu-right">
          <img src="/static/globe.png" style="margin-right: 2px" />
          <el-select v-model="$i18n.locale"
            @change="changeLanguage"
            size="small"
            class="lang-btn">
            <el-option
              v-for="item in langs"
              :key="item.value"
              :label="item.text"
              :value="item.value">
            </el-option>
          </el-select>
          <span class="project-account-info">
            <span>VT: <i class="fa fa-unlock"></i> {{ activeProjectNumber }}/{{ maxNumberProject }} - <i class="fa fa-lock"></i> {{ inactiveProjectNumber }}/{{ maxNumberProject }}</span>
          </span>
          <!-- <el-button v-if="accountInfo.subscribed" @click="$router.push({name: 'account-show', query: {tab: 'subscription'}})" type="text" size="medium" style="margin-right: 20px; color: #fdb300;">{{ accountInfo.pricing.title }}</el-button>
          <el-button v-else @click="$router.push({name: 'account-upgrade'})" type="text" size="medium" style="margin-right: 20px;">Upgrade</el-button> -->
          <!-- <a href="https://itunes.apple.com/us/app/360tovisit-virtual-tour-edit/id1445820966?mt=8" target="_blank" style="display: flex">
            <img src="/static/ios.svg" height="26px">
          </a>
          <a href="https://play.google.com/store/apps/details?id=com.visit360" target="_blank"  style="display: flex; margin-right: 20px;">
            <img src="/static/android.png" height="38px">
          </a> -->
          <!-- <el-button class="icon-notify" type="text" size="medium"><i class="el-icon-bell"></i></el-button> -->
          <el-dropdown :hide-on-click="true" @command="handleUser" style="display:flex;">
            <span class="el-dropdown-link text-white avatar-wrap">
              <div class="avatar-user" v-bind:style="{ backgroundImage: 'url(' + encodeUrl( accountInfo.avatar ? imagePath + accountInfo.avatar : '/static/avatar-default.jpg' ) + ')' }"></div>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-show="accountInfo.role !== 'editor'" command="account"><div>{{ $t('View profile') }}</div></el-dropdown-item>
              <el-dropdown-item command="logout"><div>{{ $t('Log out') }}</div></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span class="account-text">
            <span class="user-name">{{ accountInfo.name }}</span><br>
            <el-button v-if="accountInfo.pricing && accountInfo.pricing.title.toLowerCase() !== 'discovery' && accountInfo.role !== 'editor'" @click="$router.push({name: 'account-show', params: {tab: 'subscription'}})" type="text" size="medium" style="margin-right: 20px; color: #fdb300; padding: 0px;">{{ accountInfo.pricing.title }}</el-button>
            <el-button v-else-if="accountInfo.role !== 'editor'" @click="$router.push({name: 'account-upgrade'})" type="text" size="medium" style="margin-right: 20px; padding: 0px;">{{ $t('Upgrade') }}</el-button>
          </span>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ls from 'local-storage'
export default {
  name: 'HeaderTop',
  data () {
    return {
      imagePath: process.env.IMAGE_PATH,
      showMenuTop: false,
      activeIndex: 'list-project'
    }
  },
  computed: {
    ...mapGetters(['langs']),
    ...mapGetters('account', ['accountInfo', 'activeProjectNumber', 'inactiveProjectNumber']),
    maxNumberProject () {
      if (this.accountInfo.pricing) {
        return this.accountInfo.pricing.max_number_project
      } else {
        return 3
      }
    }
  },
  mounted () {
    this.activeIndex = this.$route.name
    // if (this.activeProjectNumber === null) {
    //   this.checkTotalProjects()
    // }
  },
  methods: {
    ...mapActions('account', ['removeAccountInfo']),
    ...mapActions('category', ['fetchCategories']),
    ...mapActions('message', ['fetchMessages']),
    mouseLeave () {
      this.showMenuTop = false
    },
    confirmLogout () {
      this.$confirm(this.$t('Do you want to log out?'), this.$t('Warning'), {
        confirmButtonText: this.$t('Yes'),
        cancelButtonText: this.$t('Cancel'),
        type: 'warning'
      }).then(() => {
        this.removeAccountInfo()
        window.analytics.track('w-logOff')
      }).catch(() => {

      })
    },
    handleSelect (key, keyPath) {
      if (key === 'list-agency') {
        this.openPublicProfilePage()
      } else if (key === 'list-manager') {
        this.openUserPage()
      } else {
        this.$router.push({name: key})
      }
    },
    handleUser (command) {
      if (command === 'account') {
        this.$router.push({ name: 'account-show', params: {tab: 'subscription'} })
      } else if (command === 'password') {
        this.$router.push({ name: 'change-password' })
      } else if (command === 'logout') {
        this.confirmLogout()
      } else {
      }
    },
    openPublicProfilePage () {
      if (this.accountInfo.pricing.public_profile) {
        this.$router.push({name: 'list-agency'})
      } else {
        this.$notify({
          type: 'warning',
          title: this.$t('You are using a DISCOVERY plan!'),
          message: this.$t("Please upgrade to have access to the 'Public Profile' feature.")
        })
      }
    },
    openUserPage () {
      if (this.accountInfo.pricing.manager && this.accountInfo.role !== 'editor') {
        this.$router.push({name: 'list-manager'})
      } else {
        this.$notify({
          type: 'warning',
          title: 'Warning!',
          message: this.$t('This feature is dedicated to the ENTERPRISE users!')
        })
      }
    },
    changeLanguage (value) {
      ls.set('lang', value)
      this.fetchCategories({locale: value, force: true})
      this.fetchMessages({locale: this.$i18n.locale})
    }
  },
  watch: {
    $route () {
      this.activeIndex = this.$route.name
    }
  }
}
</script>
<style>
.lang-btn .el-input__inner {
  background-color: transparent !important;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
  .custom-menu {
    display: flex;
    justify-content: space-between;
    background: #e3e8ee;
  }
  .custom-menu-right {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .el-menu {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .custom-menu .custom-menu-btn {
    display: none;
    margin: 12px 0px 0px 12px;
  }
  .custom-menu .custom-menu-btn i {
    font-size: 30px;
    padding: 5px;
  }
  .avatar-user {
    border-radius: 50%;
    cursor: pointer;
    width: 36px;
    height: 36px;
    background-size: cover;
    background-color: #DDD;
    margin-right:8px;
  }
  .avatar-wrap {
  }
  .avatar-wrap:active,
  .avatar-wrap:focus {
  }
  .custom-menu-item:active,
  .custom-menu-item:focus {
    outline: none;
  }
  .custom-menu-item {
    display: flex;
  }
  .user-name {
    font-size: 14px;
    font-weight: bold;
    color: #fff;
    padding-right: 20px;
  }
  .el-menu--horizontal .el-menu-item.is-active {
    color: #fff !important;
  }
  .el-menu--horizontal .el-menu-item.is-active {
    border-bottom: 2px solid var(--color-dark)!important;
  }
  .el-menu--horizontal .el-menu-item {
    font-size: 14px;
    /*font-weight: bold;*/
  }
  .el-menu--horizontal .el-menu-item a,
  .el-menu--horizontal .el-menu-item span {
    text-decoration: none;
    color: var(--color-dark);
  }
  .menu-icon .user-name {
    color: var(--color-dark);
  }
  /*custom css*/
  .icon-notify {
    margin-right: 20px;
    color: #2b2d50;
    font-weight: bold;
    font-size: 20px;
  }
  .project-account-info {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px 10px;
  }
  .logo-wrapper {
    padding-left: 20px;
    padding-right: 20px;
    height: 48px;
    cursor: pointer;
  }
  .logo-wrapper img {
    margin-top: 17px;
    height: 60%;
  }
  .lang-btn {
    width: 100px;
  }
  @media screen and (max-width: 768px) {
    .project-account-info {
      display: none;
    }
    .el-menu .el-menu-item {
      display: none;
    }
    .custom-menu .custom-menu-btn {
      display: block;
    }
    .logo-wrapper img {
      height: 50%;
    }
  }
  @media screen and (max-width: 425px) {
    .account-text {
      display: none;
    }
    .avatar-user {
      margin: 13px 17px 0px 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layouts/v1/HeaderTop.vue